"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ResultsCardWrapper = function ResultsCardWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "messageType", _descriptor, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "numCards",
      get: function get() {
        if (_state.DeckUI.pluralResultsCard || _state.DeckUI.deck.pluralDeck) {
          return _state.DeckUI.deck.pluralCards.length;
        } else if (_state.DeckUI.genderResultsCard || _state.DeckUI.deck.genderDeck) {
          return _state.DeckUI.deck.genderCards.length;
        } else if (_state.DeckUI.numberResultsCard || _state.DeckUI.deck.numberDeck) {
          return _state.DeckUI.deck.numberCards.length;
        } else if (_state.DeckUI.conjugationResultsCard || _state.DeckUI.deck.conjugationDeck) {
          return _state.DeckUI.deck.conjugationCards.length;
        } else if (_state.DeckUI.caseResultsCard || _state.DeckUI.deck.caseDeck) {
          return _state.DeckUI.deck.caseCards.length;
        }
      }
    }, {
      key: "correctCount",
      get: function get() {
        return _state.DeckUI.userDeck.firstAnswerCorrectCount;
      }
    }, {
      key: "percentageCorrect",
      get: function get() {
        return Math.floor(this.correctCount / this.numCards * 100);
      }
    }, {
      key: "languageId",
      get: function get() {
        return _state.DeckUI.deck.languageId || 'DE';
      }
    }, {
      key: "message",
      get: function get() {
        var _this2 = this;
        var messages = [{
          range: [0, 25],
          DE: ['Schade, übe weiter!', 'Too bad, practice more!'],
          FR: ['Dommage ! Entraîne-toi encore.', 'Too bad! Keep practicing.'],
          ES: ['¡Qué lástima, sigue practicando!', 'Too bad, practice more!']
        }, {
          range: [26, 50],
          DE: ['Nicht schlecht.', 'Not bad.'],
          FR: ['Pas mal !', 'Not bad.'],
          ES: ['Nada mal.', 'Not bad.']
        }, {
          range: [51, 75],
          DE: ['Gut gemacht!', 'Well done!'],
          FR: ['Bien joué !', 'Well done!'],
          ES: ['¡Bien hecho!', 'Well done!']
        }, {
          range: [76, 99],
          DE: ['Super gut gemacht!', 'Really well done!'],
          FR: ['Super, bon travail !', 'Super, good job!'],
          ES: ['¡Muy bien hecho!', 'Really well done!']
        }, {
          range: [100, 100],
          DE: ['Perfekt!', 'Perfect!'],
          FR: ['Parfait !', 'Perfect!'],
          ES: ['¡Perfecto!', 'Perfect!']
        }];
        var msg = null;
        (0, _lodash.each)(messages, function (message) {
          if (_this2.percentageCorrect >= message.range[0] && _this2.percentageCorrect <= message.range[1]) {
            msg = {
              target: message[_this2.languageId][0],
              source: message[_this2.languageId][1]
            };
          }
        });
        return msg;
      }
    }, {
      key: "onToggleMessageType",
      value: function onToggleMessageType() {
        this.messageType = this.messageType === 'target' ? 'source' : 'target';
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          numCards: this.numCards,
          correctCount: this.correctCount,
          percentageCorrect: this.percentageCorrect,
          message: this.message,
          messageType: this.messageType,
          languageId: this.languageId,
          onToggleMessageType: this.onToggleMessageType
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "messageType", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 'target';
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "numCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "percentageCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "percentageCorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "languageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "message"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleMessageType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleMessageType"), _class2.prototype), _class2)) || _class;
};
ResultsCardWrapper.displayName = 'ResultsCardWrapper';
var _default = exports["default"] = ResultsCardWrapper;